


export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.hooks.hook("exception:validate", (payload) => {
		console.error(`[Nuxt App Error]: Capturado pelo hook error: ${payload.message} com a stack: ${payload.originStack}`);
		console.error('[Nuxt App Error]: Payload completo:', payload);
	});

}) 